import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import './index.css';
import App from './App';

const themeConfig = {
  token: {
    colorPrimary: '#fab801',
    colorSplit: 'rgba(5, 5, 5, 0.06)',
    colorText: 'rgba(0, 0, 0, 0.88)',
    fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    fontSize: 14,
    fontSizeLG: 16,
    lineHeight: 1.57,
    lineWidthBold: 2,
    motionDurationSlow: '0.3s',
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider theme={themeConfig}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);
